import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import { useAuthStore } from '../../store/useAuthStore';
import InviteFriendsModal from './InviteFriendsModal';

//import images
import avatar1 from "../../assets/images/users/user-dummy-img.jpg";

interface ProfileDropdownProps {
    variant?: 'default' | 'avatar';
}

const getInitials = (name?: string | null) => {
    if (!name?.trim()) return 'AB';

    return name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase())
        .join('');
};

const ProfileDropdown = ({ variant = 'default' }: ProfileDropdownProps) => {

    const { user, isAdmin } = useAuthStore();

    const [isProfileDropdown, setIsProfileDropdown] = useState<boolean>(false);
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
    const isAvatarVariant = variant === 'avatar';

    //Dropdown Toggle
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className={isAvatarVariant ? "colosseum-profile-dropdown" : "ms-sm-3 header-item topbar-user"}>
                <DropdownToggle
                    tag="button"
                    type="button"
                    className={isAvatarVariant ? "colosseum-user-nav__avatar" : "btn"}
                    data-cy="profile-dropdown-toggle"
                    aria-label="Open profile menu"
                >
                    {isAvatarVariant ? (
                        <span aria-hidden="true">{getInitials(user?.username)}</span>
                    ) : (
                        <span className="d-flex align-items-center">
                            <img className="rounded-circle header-profile-user" src={avatar1}
                                alt="Header Avatar" />
                            <span className="text-start ms-xl-2">
                                <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{user?.username}</span>
                            </span>
                        </span>
                    )}
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    {/*<h6 className="dropdown-header">Welcome {user?.username}!</h6>*/}
                    {/*<DropdownItem href={process.env.PUBLIC_URL + "/profile"}><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>*/}
                    {/*    <span className="align-middle">Profile</span></DropdownItem>*/}

                    {isAdmin() && (
                      <>
                          {/*<div className="dropdown-divider"></div>*/}
                          <h6 className="dropdown-header">Admin management</h6>
                          <DropdownItem href={process.env.PUBLIC_URL + "/admin/battles"}>
                              <i className="mdi mdi-axe-battle text-muted fs-16 align-middle me-1"></i>
                              <span className="align-middle">Battles</span>
                          </DropdownItem>
                          <DropdownItem href={process.env.PUBLIC_URL + "/admin/users"} data-cy="admin-users-link">
                              <i className="mdi mdi-account-multiple text-muted fs-16 align-middle me-1"></i>
                              <span className="align-middle">Users</span>
                          </DropdownItem>
                          <DropdownItem href={process.env.PUBLIC_URL + "/admin/characters"} data-cy="admin-characters-link">
                              <i className="mdi mdi-account-group text-muted fs-16 align-middle me-1"></i>
                              <span className="align-middle">Character</span>
                          </DropdownItem>
                          <DropdownItem href={process.env.PUBLIC_URL + "/admin/parameters"} data-cy="admin-parameters-link">
                              <i className="mdi mdi-tune-variant text-muted fs-16 align-middle me-1"></i>
                              <span className="align-middle">Parameters</span>
                          </DropdownItem>
                          <div className="dropdown-divider"></div>
                      </>
                    )}



                    <DropdownItem data-cy="profile-balance">
                        <i className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Balance : <b>{user?.pointsBalance} pts</b></span>
                    </DropdownItem>

                    <DropdownItem
                        data-cy="profile-invite-friend"
                        onClick={() => setIsInviteModalOpen(true)}
                    >
                        <i className="mdi mdi-account-plus text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Invite friend</span>
                    </DropdownItem>

                    <DropdownItem href={process.env.PUBLIC_URL + "/logout"}><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">Logout</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>
            {isInviteModalOpen && user?.username && (
                <InviteFriendsModal
                    username={user.username}
                    onClose={() => setIsInviteModalOpen(false)}
                />
            )}
        </React.Fragment>
    );
};

export default ProfileDropdown;
